import { gql } from 'src/__generated__';

export const SET_DEFAULT_RESUME = gql(`
  mutation SetDefaultResume($resumeId: SetDefaultResumeInput!, $languageCode: LanguageCodeIso!) {
    setDefaultResume(input: $resumeId) {
      viewer {
        _id
        resumes(languageCode: $languageCode) {
          id
          createdDateUtc
          isDefault
          fileMetadata {
            name
            size
            virusScanStatus
            sensitiveDataInfo {
              isDetected
              __typename
            }
            uri
            __typename
          }
          origin {
            type
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`);
